var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MonitorLayoutTemplate", {
    attrs: { table_title: _vm.table_title },
    scopedSlots: _vm._u([
      {
        key: "datetime",
        fn: function() {
          return [
            _c("QpeDatetime", {
              attrs: {
                props_date: _vm.date,
                props_time: _vm.time,
                name: _vm.default_value
              },
              on: {
                "update-time": _vm.update_time,
                "change-parent-date-time": _vm.change_parent_date_time
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "data_table",
        fn: function(slot_props) {
          return [
            _c("QpeDatatable", {
              attrs: {
                data: _vm.table_data,
                headers: _vm.header,
                name: _vm.default_value,
                error_text: _vm.error_text,
                props_date: _vm.date,
                props_time: _vm.time,
                search: slot_props.search,
                show_description_dialog_btn: false,
                show_download_doc_btn: _vm.show_download_doc_btn,
                show_download_pdf_btn: _vm.show_download_pdf_btn
              },
              on: {
                "update-time": _vm.update_time,
                "change-parent-date-time": _vm.change_parent_date_time
              }
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }